import { render, staticRenderFns } from "./RentStatusDefault.vue?vue&type=template&id=57b0654d"
import script from "./RentStatusDefault.vue?vue&type=script&lang=js"
export * from "./RentStatusDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports